import HSApi from '../HSApi';
import { Icd10ItemResponse } from './icd10-item.response';

export async function getIdc10sByIds(ids: number[]): Promise<Icd10ItemResponse[]> {
  const res = await HSApi.get<Icd10ItemResponse[]>(`/icd10-definitions/list?ids=${ids.join(',')}`);

  return res.data;
}
